import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class LinkList extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {}
    
    this.config = { 
      types : [
        {
          title: 'default',
          isDefault: true,
        },
      ],
      modifiers : [ 
        'inverse'
      ],
      states : []
    }
  }

  renderLinkList(props, disabled){
    if(!props) return
    const listItems = props.map((link, index) => 
     <li key={index} className="mdn-LinkList-item">
      <a {...link.linkProps} className="mdn-LinkList-anchor" target={link.target} href={link.href} disabled={link.isDisabled || disabled}>
        {link.title}
      </a>
    </li>)
    return listItems
  }
  
  render() {
    const { data, disabled, ...rest } = this.props
    const props = clearProps(this.props)
    return <ul {...rest} className={resolveProps(this.props, this.config, 'LinkList') }>
      {this.renderLinkList(data, disabled)}
    </ul>
  }
}

LinkList.propTypes = {
  disabled: PropTypes.bool,
  data : PropTypes.array,
  config : PropTypes.object
}